// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ian4","left":"styles_left__1iGbC"};